import { IconButton, TableCell, TableRow, Typography } from "@mui/material"
import { formatDate } from "utils/HelperFunctions"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AppColors } from "resources/AppColors";
import { Sex, patientsTexts } from "locale/es";
import { format } from "date-fns";
import CheckboxWithTooltip from "components/Checkbox/CheckboxWithTooltip";

const PatientToDisplay = ({ patient, handleShowEditModal, handleShowDeleteModal }) => {

  if (!patient) return null

  const checkboxSelfRegistrationPatient = [
    { value: Boolean(patient?.acceptedTermsPrivacy), name: patientsTexts.selfRegistration.acceptedTermsPrivacy },
    { value: patient?.understandNotSharedCompany, name: patientsTexts.selfRegistration.understandNotSharedCompany },
    { value: patient?.consentShare, name: patientsTexts.selfRegistration.consentShare },
    { value: patient?.mantainData, name: patientsTexts.selfRegistration.mantainData },
  ];

  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell align="left">
        <Typography variant='body'>{patient.fullName}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography noWrap variant='body' sx={{ maxWidth: "200px", display: "inline-block" }}>{patient.user?.email}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{patient.birthDay ? formatDate(patient.birthDay) : '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{Sex[patient.sex]}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{patient?.createdDate ? format(new Date(patient?.createdDate), "dd/MM/yyyy HH:mm") : "-"}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{patient?.firstLogin ? format(new Date(patient?.firstLogin), "dd/MM/yyyy HH:mm") : "-"}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{patient?.lastAccess ? format(new Date(patient?.lastAccess), "dd/MM/yyyy HH:mm") : "-"}</Typography>
      </TableCell>
      <TableCell align="center" p={0}>
        <CheckboxWithTooltip checkboxData={checkboxSelfRegistrationPatient} />
      </TableCell>
      <TableCell align="center" p={0}>
        {handleShowEditModal &&
          <IconButton onClick={() => handleShowEditModal(patient)} size="large">
            <EditIcon sx={{ fill: AppColors.PRIMARY }} />
          </IconButton>}
        {handleShowDeleteModal &&
          <IconButton onClick={() => handleShowDeleteModal(patient)} size="large">
            <DeleteIcon sx={{ fill: AppColors.PRIMARY }} />
          </IconButton>}
      </TableCell>
    </TableRow>
  );
}

export default PatientToDisplay